export default "/images/knowledge-base-bg-dark.png?3cec33b7cb8b1f18ca5e45133710dec4";